import { z } from "zod";
import { LookupListPage } from "./LookupListPage";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

interface Row { notificationTypeCode: string; description: string; deleted: boolean; }
const schema = z.object({
  notificationTypeCode: z.string().min(1).max(40),
  description: z.string().min(1).max(200),
  deleted: z.boolean(),
});
type Form = z.infer<typeof schema>;

export function UserNotificationTypesPage() {
  return <LookupListPage<Row, Form>
    title="User notification types"
    apiPath="/api/lookups/user-notification-types"
    schema={schema}
    rowKey={(r) => r.notificationTypeCode}
    columns={[
      { id: "code", header: "Code", accessor: (r) => r.notificationTypeCode },
      { id: "desc", header: "Description", accessor: (r) => r.description },
    ]}
    toFormValues={(r) => ({ notificationTypeCode: r.notificationTypeCode, description: r.description, deleted: r.deleted })}
    toApiBody={(f) => f}
    blankFormValues={{ notificationTypeCode: "", description: "", deleted: false }}
    fields={(f) => (
      <div className="space-y-3">
        <div><Label htmlFor="c">Code</Label><Input id="c" {...f.register("notificationTypeCode")} /></div>
        <div><Label htmlFor="d">Description</Label><Input id="d" {...f.register("description")} /></div>
        <Button type="submit">Save</Button>
      </div>
    )}
  />;
}
